var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQlexTrilogyMob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 0h12.333l-37 140H0L37 0z",
    fill: "#ADDC9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.333 0h12.334l-37 140H12.333l37-140z",
    fill: "#6CC04A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.667 0H74L37 140H24.667l37-140z",
    fill: "#7C02BB"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzQiIGhlaWdodD0iMTQwIiB2aWV3Qm94PSIwIDAgNzQgMTQwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMzcgMEg0OS4zMzMzTDEyLjMzMzMgMTQwSDBMMzcgMFoiIGZpbGw9IiNBRERDOUEiLz4KPHBhdGggZD0iTTQ5LjMzMzQgMEg2MS42NjY4TDI0LjY2NjggMTQwSDEyLjMzMzRMNDkuMzMzNCAwWiIgZmlsbD0iIzZDQzA0QSIvPgo8cGF0aCBkPSJNNjEuNjY2NiAwSDczLjk5OTlMMzYuOTk5OSAxNDBIMjQuNjY2Nkw2MS42NjY2IDBaIiBmaWxsPSIjN0MwMkJCIi8+Cjwvc3ZnPgo=";
export { SvgQlexTrilogyMob as ReactComponent };